export default __webpack_public_path__ + "static/media/Teams.a9c2700e.svg";